import { type FC } from 'react';
import cn from 'classnames';

// import { transform } from 'framer-motion';
import { useStorePrice } from '@/common/hooks/apple-price';
import { Ticker } from '@/components/common/Ticker/Ticker';
import { StringMain, StringSmall } from '@/components/Typography/Typography';

import { MainButton, type MainButtonProps } from '../Button/Button';

import css from './styles.module.scss';

interface BuyForTgStarButtonProps extends Omit<MainButtonProps, 'text'> {
  price?: number;
  discountPrice: number;
  discountPercentage?: number;
  wrapperClassName?: string;
}

const BuyForTgStarButton: FC<BuyForTgStarButtonProps> = ({
  price,
  discountPrice,
  discountPercentage,
  wrapperClassName,
  ...btnProps
}) => {
  // const calcBasePrice =
  //   discountPercentage && !price
  //     ? transform([0, 100 - discountPercentage], [0, discountPrice], {
  //         clamp: false,
  //       })
  //     : undefined;

  function calcBasePrice(): number {
    if (!discountPercentage || discountPercentage === 0) return discountPrice;
    const pricePercentage = 100 - discountPercentage;
    const multiplier = pricePercentage / 100;
    const basePrice = discountPrice / multiplier;

    return parseFloat(basePrice.toFixed(2));
  }
  const basePrice = calcBasePrice();
  // iOS app: the App Store price the player is charged, without the
  // Telegram discount maths (it does not match App Store price points)
  const storePrice = useStorePrice(discountPrice);
  const showDiscount = !!discountPercentage && !storePrice;

  return (
    <div className={cn('relative', wrapperClassName)}>
      {showDiscount && (
        <div className="absolute -top-[4px] -right-[4px]">
          <Ticker variant="gold-small" text={`-${discountPercentage}%`} />
        </div>
      )}
      <MainButton
        text=""
        {...btnProps}
        className={cn('flex items-center h-8 gap-1', btnProps.className)}
      >
        {showDiscount && (basePrice || price) && (
          <StringSmall
            weight="medium"
            className={cn(
              '!text-white/40 relative text-crossed-out',
              css.discount,
            )}
          >
            ${price ? price : basePrice}
          </StringSmall>
        )}
        <StringMain
          weight="extrabold"
          className={cn('!text-white/80', css.price)}
        >
          {storePrice ?? `$${discountPrice}`}
        </StringMain>
      </MainButton>
    </div>
  );
};

export { BuyForTgStarButton };
